import { render, staticRenderFns } from "./ManagementFeeDetail.vue?vue&type=template&id=01bd27fc&scoped=true"
import script from "./ManagementFeeDetail.vue?vue&type=script&lang=js"
export * from "./ManagementFeeDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bd27fc",
  null
  
)

export default component.exports